<template>
    <div class="card-orcamento-final-produto-novo">
        <g-card
        :temCabecalho = "false"
        :temBordaTopProps="false"
        >
            <div class="container-cabecalho-finalizado">
                <img class="orcamento-final-img icone-carta" src="@/assets/imgs/icone_orçamento_menor.svg"/>
                <div class="Titulo-Inicial titulo-finalizado">
                    <div class="pdf-orcamento-titulo"> Orçamento <div class="container-numero">#<div class="cor-numero">{{orcamento}}</div></div> </div>
                </div>
                <div class="container-rep-unidade">
                    <div class="representante">
                        <div class="titulo-rep"> Representante: &nbsp;</div>
                        <div class="conteudo-rep">{{nomeRepre}}</div>
                    </div>
    
                    <div class="unidade">
                        <div class="titulo-unidade"> Unidade: &nbsp;</div>
                        <div class="conteudo-unidade" >{{Empresa}}</div>
                    </div>
                </div>
            </div>


            <div class="espacamento-pdf">
                <div class="titulo-grupo-detalhes"> CLIENTE </div>
                <div class="grupo-cliente">
                    <div class="cliente-cnpj">
                        <div class="cnpj titulo-conteudo-detalhes"> CNPJ </div>
                        <div class="cnpj label-conteudo">{{InformacaoClienteArray.cnpj}}</div> 
                    </div>

                    <div class="cliente-codigo">
                        <div class="codigo titulo-conteudo-detalhes" > Código </div>
                        <div class="codigo label-conteudo">{{InformacaoClienteArray.codigo}}</div> 
                    </div>

                    <div class="cliente-razaosocial">
                        <div class="razaosocial titulo-conteudo-detalhes"> Razão Social </div>
                        <div class="razaosocial label-conteudo">{{InformacaoClienteArray.razaoSocial}}</div> 
                    </div>

                    <div class="cliente-estado">
                        <div class="estado titulo-conteudo-detalhes"> Estado </div>
                        <div class="estado label-conteudo">{{InformacaoClienteArray.siglaEstado}}</div> 
                    </div>

                    <div class="cliente-cidade">
                        <div class="cidade titulo-conteudo-detalhes"> Cidade </div>
                        <div class="cidade label-conteudo">{{InformacaoClienteArray.nomeCidade}}</div> 
                    </div>

                    <div class="cliente-segmento">
                        <div class="segmento titulo-conteudo-detalhes"> Segmento </div>
                        <div class="segmento label-conteudo">{{InformacaoClienteArray.clienteTipoTexto}}</div> 
                    </div>

                    <div class="cliente-contato">
                        <div class="contato titulo-conteudo-detalhes"> Contato </div>
                        <div class="contato label-conteudo">{{InformacaoClienteArray.nomeContato}}</div> 
                    </div>

                    <div class="cliente-telefone">
                        <div class="telefone titulo-conteudo-detalhes"> Telefone </div>
                        <div class="telefone label-conteudo">{{InformacaoClienteArray.numeroTelefone}}</div> 
                    </div>

                    <div class="cliente-ramal">
                        <div class="ramal titulo-conteudo-detalhes"> Ramal </div>
                        <div class="ramal label-conteudo">{{InformacaoClienteArray.numeroRamal}}</div> 
                    </div>

                    <div class="cliente-suframa">
                        <div class="suframa titulo-conteudo-detalhes"> Suframa </div>
                        <div class="suframa label-conteudo">{{InformacaoClienteArray.numeroSuframa || 'Não cadastrado'}}</div> 
                    </div>

                    <div class="cliente-incentivo">
                        <div class="incentivo titulo-conteudo-detalhes"> Possui incentivo fiscal? </div>
                        <div class="incentivo label-conteudo">{{this.ICMS + this.IPI + this.PisCofins == '' ? 'NÃO' : this.ICMS + this.IPI + this.PisCofins}}</div> 
                    </div>
                </div>

                <div class="titulo-grupo-detalhes"> LOTE E FRETE </div>
                <div class="grupo-loteFrete">
                    <div class="lotefrete-riscofaca">
                        <div class="titulo-conteudo-resumo-final">Risco Faca</div>
                        <div class="label-conteudo-resumo-final">{{InformacaoLoteFreteArray.getRiscoFaca || 'NÃO'}}</div>                        
                    </div>
                    <div class="loteFrete-prototipo">
                        <div class="titulo-conteudo-resumo-final">Protótipo</div>
                        <div class="label-conteudo-resumo-final">{{InformacaoLoteFreteArray.getPrototipo || 'NÃO'}}</div>
                    </div>

                    <div class="lotefrete-lote">
                        <div class="titulo-conteudo-resumo-final"> Lote </div>
                        <div class="label-conteudo-resumo-final">{{InformacaoLoteFreteArray.informacaoLoteText}}</div>
                    </div>
                    <div class="loteFrete-descricao-lote" v-if="InformacaoLoteFreteArray.informacaoLoteText !== 'Não'">                            
                        <div class="titulo-conteudo-resumo-final"> Descrição Lote </div>
                        <div class="label-conteudo-resumo-final">{{DescricaoLote || 'Não possui'}}</div>
                    </div>

                    <div class="lotefrete-sequencia">
                        <div class="titulo-conteudo-resumo-final"> Sequência </div>
                        <div class="label-conteudo-resumo-final">{{InformacaoLoteFreteArray.getSequencia}}</div>
                    </div>

                    <div class="loteFrete-descricao-sequencia" v-if="InformacaoLoteFreteArray.sequencia != false">                            
                        <div class="titulo-conteudo-resumo-final"> Descrição Sequência </div>
                        <div class="label-conteudo-resumo-final">{{OrcamentoDescricaoSequencia || 'Não possui'}}</div>
                    </div>

                    <div class="lotefrete-frete">
                        <div class="titulo-conteudo-resumo-final"> Frete </div>
                        <div class="label-conteudo-resumo-final">{{InformacaoLoteFreteArray.freteEnum}}</div>
                    </div>

                    <div class="lotefrete-estado">
                        <div class="titulo-conteudo-resumo-final"> UF </div>
                        <div class="label-conteudo-resumo-final">{{InformacaoLoteFreteArray.siglaEstado}}</div>
                    </div>

                    <div class="lotefrete-cidade">
                        <div class="titulo-conteudo-resumo-final"> Cidade </div>
                        <div class="label-conteudo-resumo-final">{{InformacaoLoteFreteArray.nomeCidade}}</div>
                    </div>

                    <div class="lotefrete-tipoFrete">
                        <div class="titulo-conteudo-resumo-final"> Tipo Frete </div>
                        <div class="label-conteudo-resumo-final">{{InformacaoLoteFreteArray.tipoFreteEnumTexto || 'Sem Tipo Frete'}}</div>
                    </div>
                </div>

                <div class="html2pdf__page-break"/>

                <div class="titulo-grupo-detalhes"> INFORMAÇÕES BÁSICAS </div>
                <div class="grupo-infoBasicas">
                    <div class="infoBasicas-nomeProduto">
                        <div class="nomeProduto titulo-conteudo-detalhes"> Nome do Produto </div>
                        <div class="nomeProduto label-conteudo">{{InformacaoOrcamentoProdutoArray.nomeProduto}}</div> 
                    </div>

                    <div class="infoBasicas-amostraRef">
                        <div class="titulo-conteudo-detalhes"> Deseja utilizar amostra de referência? </div>
                        <div class="grid-infoBasicas-amostraRef">
                            <div class="acompanha-amostra checkbox">
                                <PCheckBox id="acompanha-amostra" :binary="true" v-model="OrcamentoAmostra" disabled="DesabilitaCheckBox"/>
                                <label for="acompanha-amostra" class="amostraRef label-checkbox"> Acompanha Amostra </label> 
                            </div>
                            <div class="especificacoes-tecnicas checkbox">
                                <PCheckBox id="especificacoes-tecnicas" :binary="true" v-model="OrcamentoAmostraEspTecnica" disabled="DesabilitaCheckBox"/>
                                <label for="especificacoes-tecnicas" class="amostraRef label-checkbox"> Todas as especificações técnicas conforme amostra </label> 
                            </div>
                            <div class="outros-materiais checkbox">
                                <PCheckBox id="outros-materiais" :binary="true" v-model="OrcamentoAmostraOutros" disabled="DesabilitaCheckBox"/>
                                <label for="outros-materiais" class="amostraRef label-checkbox"> Outros materiais do Cliente </label> 
                            </div>
                            <div class="descricao-outros-materiais checkbox">
                                <label for="descricao-outros-materiais" class="amostraRef label-label-conteudo">{{OrcamentoAmostraDescOutros}}</label> 
                            </div>
                        </div>
                    </div>
                    
                    <div class="infoBasicas-quantidade">
                        <div class="quantidade titulo-conteudo-detalhes"> Quantidade </div>
                        <div class="quantidade label-conteudo" v-for="data in OrcaQuantidade" 
                            :key="data.id">{{data.quantidade}}</div> 
                    </div>
                    
                    <div class="infoBasicas-diaCarregamento">
                        <div class="diaCarregamento titulo-conteudo-detalhes"> Dia do Carregamento </div>
                        <div class="diaCarregamento label-conteudo" v-for="data in OrcaQuantidadeDiaCarregamento" 
                            :key="data.id">{{data.dataCarregamentoFormato}}</div> 
                    </div>


                    <div class="infoBasicas-observacao">
                        <div class="observacao titulo-conteudo-detalhes"> Obs. sobre Quantidade / Carregamento / Consumo </div>
                        <PTextArea id="obsInfoBasicas" v-model="InformacaoObservacao" rows="4" cols="30" disabled></PTextArea> <!--back -->
                    </div>
                </div>

                <div class="componentes" v-for="data in InformacaoOrcamentoComponenteArray" :key="data.id">
                    <div class="titulo-grupo-detalhes" v-if="InformacaoOrcamentoComponenteArray.length > 0"> COMPONENTES </div>
                    <div class="topico">
                        <div class="grupo-componentes">
                        <div class="componentes-numero">
                            <div class="numero titulo-conteudo-detalhes"> Número </div>
                            <div class="numero label-conteudo">{{data.numeroComponente}}</div>
                        </div>

                        <div class="componentes-componentes">
                            <div class="componentes titulo-conteudo-detalhes"> Componentes </div>
                            <div class="componentes label-conteudo">{{data.nomeComponente}}</div>
                        </div>

                        <div class="componentes-medidas">
                            <div class="medidas titulo-conteudo-detalhes"> Medidas </div>
                            <div class="medidas label-conteudo">{{data.descMedidasEnum || data.numeroComprimento + 'x' + data.numeroLargura + 'x' + data.numeroAltura + 'x' + data.numeroAlturaTampa}}</div>
                        </div>

                        <div class="componentes-corFrente">
                            <div class="corFrente titulo-conteudo-detalhes"> Cor Frente </div>
                            <div class="corFrente label-conteudo">{{data.descCoresFrenteEnum}}</div>
                        </div>

                        <div class="componentes-corVerso">
                            <div class="corVerso titulo-conteudo-detalhes"> Cor Verso </div>
                            <div class="corVerso label-conteudo">{{data.descCoresVersoEnum}}</div>
                        </div>

                        <div class="componentes-acabFrente">
                            <div class="acabFrente titulo-conteudo-detalhes"> Acabamento Frente </div>
                            <div class="acabFrente label-conteudo">{{data.descAcabamentoFrenteEnum}}</div>
                        </div>

                        <div class="componentes-acabVerso">
                            <div class="acabVerso titulo-conteudo-detalhes"> Acabamento Verso </div>
                            <div class="acabVerso label-conteudo">{{data.descAcabamentoVersoEnum}}</div>
                        </div>

                        <div class="componentes-capaInt">
                            <div class="capaInt titulo-conteudo-detalhes"> Capa Interna </div>
                            <div class="capaInt label-conteudo">{{data.descCapaInternaEnum}}</div>
                        </div>

                        <div class="componentes-gramaturaInt">
                            <div class="gramaturaInt titulo-conteudo-detalhes"> Gramatura Capa Interna </div>
                            <div class="gramaturaInt label-conteudo">{{data.numeroGramaturaCapaInterna}}</div>
                        </div>

                        <div class="componentes-capaExt">
                            <div class="capaExt titulo-conteudo-detalhes"> Capa Externa </div>
                            <div class="capaExt label-conteudo">{{data.descCapaExternaEnum}}</div>
                        </div>

                        <div class="componentes-gramaturaExt">
                            <div class="gramaturaExt titulo-conteudo-detalhes"> Gramatura Capa Externa</div>
                            <div class="gramaturaExt label-conteudo">{{data.numeroGramaturaCapaExterna}}</div>
                        </div>

                        <div class="componentes-material">
                            <div class="material titulo-conteudo-detalhes"> Material </div>
                            <div class="material label-conteudo">{{data.descMaterialEnum}}</div>
                        </div>

                        <div class="componentes-papelOnda">
                            <div class="papelOnda titulo-conteudo-detalhes"> Papel de Onda </div>
                            <div class="papelOnda label-conteudo">{{data.descPapelOndaEnum}}</div>
                        </div>

                        <div class="componentes-gramaturaPO">
                            <div class="gramaturaPO titulo-conteudo-detalhes"> Gramatura Papel Onda</div>
                            <div class="gramaturaPO label-conteudo">{{data.numeroGramaturaPapelOnda}}</div>
                        </div>

                        <div class="componentes-onda">
                            <div class="onda titulo-conteudo-detalhes"> Onda </div>
                            <div class="onda label-conteudo">{{data.descOndaEnum}}</div>
                        </div>

                        <!-- <div class="componentes-sistema">
                            <div class="sistema titulo-conteudo-detalhes"> Sistema </div>
                            <div class="sistema label-conteudo">{{data.descSistemaEnum}}</div>
                        </div> -->

                        <div v-if = "data.descricaoSistema == 0">
                    <div class="componentes-codigo">
                            <div class="titulo-conteudo-resumo-final"> Código </div>
                            <div class="label-conteudo-resumo-final">{{data.codigoSistema}}</div>
                        </div>
                    </div>
                    
                    <div v-if = "data.descricaoSistema == 0">
                        <div class="componentes-codigo">
                            <div class="titulo-conteudo-resumo-final"> Descrição do Sistema</div>
                            <div class="label-conteudo-resumo-final">{{data.sistema}}</div>
                        </div>

                    </div>   

                    <div v-if = "data.descricaoSistema == 2">
                        <div class="componentes-codigo">
                            <div class="titulo-conteudo-resumo-final"> Produto </div>
                            <div class="label-conteudo-resumo-final">{{data.produtoSistema}}</div>
                        </div>
                    </div> 

                    <div v-if = "data.descricaoSistema == 3">
                        <div class="componentes-codigo">
                            <div class="titulo-conteudo-resumo-final"> Protótipo </div>
                            <div class="label-conteudo-resumo-final">{{data.prototipoSistema}}</div>
                        </div>
                    </div> 
                        <div class="html2pdf__page-break"/>
                        </div>
                    </div>
                </div>

                <div class="grupo-demaisCaract">
                    <div class="titulo-grupo-detalhes"> DEMAIS CARACTERÍSTICAS </div>
                    <div class="grid-grupo-demaisCaract">
                        <div class="demaisCaract-gerais">
                            <div class="titulo-conteudo-detalhes"> Gerais </div>
                            <div class="fsc checkbox">
                                <PCheckBox id="fsc" :binary="true" v-model="OrcamentoGeraisFsc" disabled="DesabilitaCheckBox"/>
                                <label for="FSC" class="checkboxGerais label-checkbox"> Cliente exige selo FSC nesse produto </label> 
                            </div>
                            <div class="legislacao checkbox">
                                <PCheckBox id="legislacao" :binary="true" v-model="OrcamentoGeraisLegislacao" disabled="DesabilitaCheckBox"/>
                                <label for="legislacao" class="checkboxGerais label-checkbox"> Existe legislação ou requisito regulamentar específico </label> 
                            </div>
                        </div>

                        <div class="demaisCaract-embalagem">
                            <div class="titulo-conteudo-detalhes"> Embalagem coletiva específica </div>
                            <div class="grid-demaisCaract-embalagem">
                                <div class="filme-encolhivel checkbox">
                                    <PCheckBox id="filme-encolhivel" :binary="true" v-model="OrcamentoEmbalagemFilme" disabled="DesabilitaCheckBox"/>
                                    <label for="filme-encolhivel" class="caixaEmbalagem label-checkbox"> Filme encolhível </label> 
                                </div>
                                <div class="caixa-coletiva checkbox">
                                    <PCheckBox id="caixa-coletiva" :binary="true" v-model="OrcamentoEmbalagemCaixaColetiva" disabled="DesabilitaCheckBox"/>
                                    <label for="caixa-coletiva" class="caixaEmbalagem label-checkbox"> Caixa coletiva </label> 
                                </div>
                                <div class="palete checkbox">
                                    <PCheckBox id="palete" :binary="true" v-model="OrcamentoEmbalagemPalete" disabled="DesabilitaCheckBox"/>
                                    <label for="palete" class="caixaEmbalagem label-checkbox"> Palete </label> 
                                </div>
                                <div v-if="OrcamentoEmbalagemPalete" class="melhor-aproveitamento-palete checkbox">
                                    <PCheckBox id="palete" :binary="true" v-model="MelhorAproveitamento" disabled="DesabilitaCheckBox"/>
                                    <label for="palete" class="melhor-aproveitamento-checkbox label-checkbox"> Melhor Aproveitamento </label>
                                </div>

                                <div v-if="OrcamentoEmbalagemPalete" class="altura-palete checkbox">
                                    <label for="descricao-outras-embalagens" class="label-conteudo">C: {{ComprimentoPalete}} X L: {{LarguraPalete}} X A: {{AlturaPalete}}</label>
                                </div>

                                <div v-if="OrcamentoEmbalagemPalete" class="observacao-palete checkbox">
                                    <label for="descricao-outras-embalagens" class="label-conteudo">Obs. Palete: {{ObservacaoPalete}}</label>
                                </div>
                                <div class="outras-embalagens checkbox">
                                    <PCheckBox id="outras-embalagens" :binary="true" v-model="OrcamentoEmbalagemOutros" disabled="DesabilitaCheckBox"/>
                                    <label for="outras-embalagens" class="caixaEmbalagem label-checkbox"> Outros </label> 
                                </div>
                                <div class="descricao-outras-embalagens checkbox">
                                    <label for="descricao-outras-embalagens" class="label-conteudo">{{OrcamentoEmbalagemDescOutros}}</label>
                                </div>
                            </div>
                        </div>

                        <div class="demaisCaract-critica">
                            <div class="titulo-conteudo-detalhes"> Crítica de processo </div>
                            <div class="grid-demaisCaract-critica">
                                <div class="input-checkbox critica-container">                             
                                    <label class="label-checkbox" for="fechamento-maquina"
                                    > O produto terá fechamento por máquina por parte do cliente? </label>          
                                    <label class="label-checkbox" for="fechamento-maquina"
                                    > {{ OrcamentoCritica3 ? 'SIM' : 'NÃO' }} </label>     
                                </div> 
                            </div>
                        </div>

                        <div v-if="this.quebraLinha">
                            <div class="html2pdf__page-break"/>
                        </div>

                        <div class="demaisCaract-observacoes">
                            <div class="titulo-conteudo-detalhes"> Observações </div>
                            <PTextArea id="obsGerais" v-model="InformacaoObservacoesGerais" rows="4" cols="30" disabled></PTextArea> <!--back -->
                        </div>
                    </div>
                </div>
            </div>
        </g-card>
    </div>
</template>

<script>
import PDFOrcamentoFinal from './PDFOrcamentoFinal.js'
export default PDFOrcamentoFinal
</script>

<style scoped>
.pdf-orcamento-titulo{
    display: flex;
}
.container-numero{
    display: flex;
    justify-content: left;
}
.cor-numero{
    color: #fcb316;
    font-family: "MontSerrat";
    font-weight: 700;
}
.conteudo-rep{
    font-family: "MontSerrat";
    color: #8a8a8a;
}
.conteudo-unidade{
    font-family: "MontSerrat";
    color: #8a8a8a;
}
.titulo-rep{
    font-family: "MontSerrat";
    font-weight: bold;
    color: #4f2c19;
}
.titulo-unidade{
    font-family: "MontSerrat";
    font-weight: bold;
    color: #4f2c19;
}
.container-rep-unidade {
    display: inline;
    text-align: right;
    color: #8a8a8a;
    grid-area: container-rep-unidade;
  }

.titulo-finalizado {
  grid-area: titulo-finalizado;
}
.Titulo-Inicial {
  font: normal normal 600 20px/31px Montserrat;
  color: #4f2c19;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  margin-left: 30px;
}
.icone-carta {
  grid-area: icone-carta;
  align-self: center;
  justify-self: center;
}
.orcamento-final-img {
  width: 48px;
}
.container-cabecalho-finalizado {
  /* display: grid;
  grid-template-columns: 1fr 3fr 0.25fr 0.25fr;
  grid-template-rows: 1fr;
  grid-auto-columns: 1fr;
  gap: 0px 0px;
  grid-auto-flow: row;
  grid-template-areas: "icone-carta titulo-finalizado botao-compartilhar botao-imprimir"; */

  display: flex;
  justify-content: space-between;
  padding-bottom: 15px;
  margin-left: 10px;
  /* display: flex; */
  padding-bottom: 15px;
}
.label-representante-unidade{
    color: #8a8a8a;
    text-align: left;
    font-family: "MontSerrat";
    margin-top: 15px;
    margin-bottom: 0px;
}
.grupo-cliente{
    display: grid;
    grid-template-columns: repeat(3, minmax(4em, 1fr));
    grid-template-rows: repeat(4, auto);
    column-gap: 3%;
}
.grupo-loteFrete{
    display: grid;
    grid-template-columns: repeat(4, minmax(4em, 1fr));
    grid-template-rows: repeat(4, auto);
    column-gap: 3%;
}
.grupo-infoBasicas{
    display: grid;
    grid-template-columns: repeat(3, minmax(4em, 1fr));
    grid-template-rows: repeat(4, auto);
    column-gap: 3%;
}
.infoBasicas-nomeProduto { grid-area: 1 / 1 / 2 / 2; }
.infoBasicas-amostraRef { grid-area: 2 / 1 / 3 / 3; }
.infoBasicas-quantidade { grid-area: 1 / 2 / 2 / 3; }
.infoBasicas-diaCarregamento { grid-area: 1 / 3 / 2 / 4; }
.infoBasicas-observacao { grid-area: 3 / 1 / 4 / 4; }
.grupo-componentes{
    display: grid;
    grid-template-columns: repeat(3, minmax(4em, 1fr));
    grid-template-rows: repeat(4, auto);
    column-gap: 3%;
}
.representante, .unidade{
    display: flex;
    flex-direction: row;
}
.orcamentoInfo-titulo {
    color:#4F2C19;
    text-align: left;
    font-weight: bold;
}

.orcamentoInfo-subtitulo { font-size: 15px; }

.representante-label, .unidade-label, .orcamentoInfo-subtitulo {
    color:#4F4C4D;
    font-family: 'MontSerrat';
    font-weight: bold;
    text-align: left;
    display: flex;
}

.representante-conteudo, .unidade-conteudo {
    color: #3E3E3E;
    font-family: 'MontSerrat';
    text-align: left;
    font-weight: 500;
}

.header-icons {
    display: flex;
    flex-direction: row;
    column-gap: 5px;
}



.checkbox {
    display: flex;
    padding-top: 3px;
    padding-bottom: 3px;
}
.label-checkbox{
    color: #8A8A8A;
    text-align: left;
    font-size: 15px;
    font-family: 'MontSerrat';
}
.label-checkbox { margin-left: 5px; }

.btnOrcamento {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    column-gap: 50px;
    row-gap: 15px;
    margin-top: 50px;
}

.p-disabled, .p-component:disabled {
    opacity: 1;
}
.p-inputtext {
    width: 100%;
}
.p-button {
    margin-top: 0;
    padding-top: 0;
}

.critica-container{
display: flex;
flex-direction: column;
gap: 1rem;
}

@media (min-width: 310px) {}

@media (min-width:368px) {}

@media (min-width:600px) {}

@media (min-width:801px) {}

@media (min-width:1025px) {}

@media (min-width:1281px) {}

@media (min-width:1500px) {}
</style>



